// Third-party Imports
import styled from '@emotion/styled'

// Util Imports
import { menuClasses } from '../../utils/menuClasses'

// Style Imports
import { menuButtonStyles } from '../../components/vertical-menu/MenuButton'

const StyledVerticalMenuItem = styled.li`
  position: relative;
  margin-block-start: 4px;
  ${({ menuItemStyles }) => menuItemStyles};
  ${({ rootStyles }) => rootStyles};

  > .${menuClasses.button} {
    ${({ level, disabled }) =>
    menuButtonStyles({
      level,
      disabled
    })};
    ${({ buttonStyles }) => buttonStyles};
    ${({ isCollapsed }) =>
    isCollapsed &&
    `
      padding-inline: 0;
      padding-inline-start: 8px;
      display: flex;
      justify-content: center;
      width: 100%;
      & .${menuClasses.icon} {
        margin-inline-end: 0;
      }
    `}
  }
`

export default StyledVerticalMenuItem
